import React, { createContext, ReactNode, useContext, useState } from 'react';
import log, { LogLevelDesc } from 'loglevel';

interface LoggerContextType {
  log: typeof log;
  changeLogLevel: (
    level: 'trace' | 'debug' | 'info' | 'warn' | 'error'
  ) => void;
}

const LoggerContext = createContext<LoggerContextType | undefined>(undefined);

interface LoggerProviderProps {
  children: ReactNode;
}

export const LoggerProvider: React.FC<LoggerProviderProps> = ({ children }) => {
  // set log level debug when local environment
  const [logLevel, setLogLevel] = useState<LogLevelDesc>(
    process.env.REACT_APP_ENVIRONMENT === 'local' ? 'debug' : 'error'
  );

  log.setLevel(logLevel);

  const changeLogLevel = (level: LogLevelDesc) => {
    setLogLevel(level);
    log.setLevel(level);
  };

  return (
    <LoggerContext.Provider value={{ log, changeLogLevel }}>
      {children}
    </LoggerContext.Provider>
  );
};

export const useLogger = () => {
  const context = useContext(LoggerContext);

  if (!context) {
    throw new Error('useLogger must be used within a LoggerProvider');
  }

  return context;
};
